module.exports = __webpack_public_path__ + "img/expand-less.7d39c77c.svg";